module.exports = __webpack_public_path__ + "static/img/99.31b8526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/99.png
// module id = czHL
// module chunks = 0